export const HOME_COMPONENTS = ['highlights', 'trending', 'top_categories', 'sports_competition_recs'] as const;

export type HomeComponent = (typeof HOME_COMPONENTS)[number];

export interface HomeRequest {
    include: readonly HomeComponent[];
}

/** Canonical component identity for requests and caches. */
export function canonicalHomeSelection(include: readonly HomeComponent[]): string {
    if (include.length === 0 || include.some((component) => !HOME_COMPONENTS.includes(component))) {
        throw new Error('Home selection must contain recognized components');
    }
    return [...new Set(include)].sort().join(',');
}

export function homeQueryString(request: HomeRequest): string {
    const include = canonicalHomeSelection(request.include);
    return `?${new URLSearchParams({ include })}`;
}
